export class UserNotificationConfig {
	allowCallNotification: boolean = true;
	allowLogsheetNotification: boolean = true;
	allowMessageNotification: boolean = true;

	buildModel(config: Partial<UserNotificationConfig> = {}) {
		if (!config) return this;

		for (const key in config) {
			if (Object.prototype.hasOwnProperty.call(config, key)) {
				this[key] = config[key] !== undefined ? config[key] : this[key];
			}
		}
		return this;
	}

	buildObj(config: Partial<UserNotificationConfig> = {}) {
		return new UserNotificationConfig().buildModel(config).toObj();
	}

	toObj() {
		return {
			allowCallNotification: this.allowCallNotification,
			allowLogsheetNotification: this.allowLogsheetNotification,
			allowMessageNotification: this.allowMessageNotification,
		};
	}
}
